import { TResetPasswordFormValues } from './ResetPassword.types';

export const RESET_PASSWORD_FORM_DEFAULT_VALUES: TResetPasswordFormValues = {
  password: '',
  confirmPassword: '',
};
